/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Access_Denied_TitleInputs */

const en_access_denied_title = /** @type {(inputs: Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No access`)
};

const ja_access_denied_title = /** @type {(inputs: Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセス権がありません`)
};

const fr_access_denied_title = /** @type {(inputs: Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun accès`)
};

const de_access_denied_title = /** @type {(inputs: Access_Denied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Zugriff`)
};

/**
* | output |
* | --- |
* | "No access" |
*
* @param {Access_Denied_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const access_denied_title = /** @type {((inputs?: Access_Denied_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Access_Denied_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_access_denied_title(inputs)
	if (locale === "ja") return ja_access_denied_title(inputs)
	if (locale === "fr") return fr_access_denied_title(inputs)
	return de_access_denied_title(inputs)
});